export const MENU_LIST_MAX_HEIGHT = 250
